import i18n from '../i18n';

export function todayIso(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function shiftedIso(days: number): string {
  const now = new Date();
  now.setDate(now.getDate() + days);
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function isOverdue(dueDate: string | null): boolean {
  return dueDate !== null && dueDate < todayIso();
}

export function formatDueDate(dueDate: string): string {
  if (dueDate === todayIso()) return i18n.t('dates.today');
  if (dueDate === shiftedIso(1)) return i18n.t('dates.tomorrow');
  if (dueDate === shiftedIso(-1)) return i18n.t('dates.yesterday');
  const date = new Date(`${dueDate}T00:00:00`);
  return new Intl.DateTimeFormat(i18n.language, { day: 'numeric', month: 'short' }).format(date);
}

export function formatDueTime(dueTime: string): string {
  return dueTime.slice(0, 5);
}

/**
 * Zwraca pusty tekst zamiast rzucać na braku daty. Intl na Invalid Date rzuca
 * RangeError, a że render jest synchroniczny, jeden pusty timestamp z API
 * wygaszał całą stronę do białego ekranu.
 */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(i18n.language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(i18n.language, {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  }).format(date);
}

export function isoToLocalInput(iso: string | null): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
}

export function localInputToIso(value: string): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}

export function normalizeDueTime(value: string): string | null {
  if (!value) return null;
  return value.length === 5 ? `${value}:00` : value;
}
